import styled from 'styled-components'
import tw from 'twin.macro'

export const ContainerWrapper = styled.div`
  ${tw`h-8 w-8 items-center justify-center flex`}
`
